import { isNil, get, isEmpty } from 'lodash-es';
import {
  VEHICLE_HISTORY_POINTS_EXPERIAN,
  getHistoryPointsExperian,
} from 'site-modules/shared/components/inventory/helpers/vehicle-history-helper';
import {
  ADVERTISED_PRICE_SOURCE,
  HAS_FEES_TEXT_SHORT,
  NO_FEES_TEXT,
  UNKNOWN_FEES_TEXT,
} from 'site-modules/shared/constants/inventory/prices';
import {
  hasDealerFees,
  hasNoDealerFees,
  hasUnknownDealerFees,
} from 'site-modules/shared/utils/inventory/dealer-fees-utils';

const HISTORY_BOOLEAN_KEYS = [
  'personalUseOnly',
  'salvageHistory',
  'frameDamage',
  'lemonHistory',
  'theftHistory',
  'cleanTitle',
  'freeHistoryReport',
  'noAccidents',
];

const HISTORY_KEYS = [...HISTORY_BOOLEAN_KEYS, 'ownerText', 'accidentText', 'usageType', 'historyProvider'];

const DEFAULT_HISTORY_VAL = 'Not Provided';

/**
 * Takes object of history data and transforms it for UI and SEO schema
 * @param {Object} historyData Vehicle history data
 * @returns {Object} Transformed vehicle history data
 */
export function transformVehicleHistory(historyData) {
  const experianHistoryPoints = isEmpty(historyData) ? [] : getHistoryPointsExperian(historyData);

  return HISTORY_KEYS.reduce((result, key) => {
    let val = get(historyData, key);

    if (VEHICLE_HISTORY_POINTS_EXPERIAN[key]) {
      val = get(
        experianHistoryPoints.find(point => point && point.name === key),
        'content',
        DEFAULT_HISTORY_VAL
      );
    } else if (isNil(val)) {
      val = DEFAULT_HISTORY_VAL;
    } else if (HISTORY_BOOLEAN_KEYS.includes(key)) {
      val = val ? 'Yes' : 'No';
    }

    return { ...result, [key]: val };
  }, {});
}

export const getDealerFeesLinkText = vinData => {
  const { prices: { advertisedPrice, advertisedPriceSource } = {} } = vinData ?? {};

  if (hasUnknownDealerFees(vinData)) return UNKNOWN_FEES_TEXT;

  if (advertisedPriceSource === ADVERTISED_PRICE_SOURCE.DEALER_MSRP || Number(advertisedPrice) <= 0) return null;

  if (hasDealerFees(vinData)) return HAS_FEES_TEXT_SHORT;

  return hasNoDealerFees(vinData) ? NO_FEES_TEXT : null;
};
